import { css } from 'styled-components';

/** Wrapper around a data table — horizontal scroll on narrow viewports */
export const scrollableTableWrapStyles = css`
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  width: 100%;
`;

/** Use on styled.table so columns keep natural width and the wrapper scrolls */
export const scrollableTableSizing = css`
  width: max-content;
  min-width: 100%;
`;
